import { render, staticRenderFns } from "./uploadPersonInfo.vue?vue&type=template&id=21ad31de&scoped=true&"
import script from "./uploadPersonInfo.vue?vue&type=script&lang=js&"
export * from "./uploadPersonInfo.vue?vue&type=script&lang=js&"
import style0 from "./uploadPersonInfo.vue?vue&type=style&index=0&id=21ad31de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ad31de",
  null
  
)

export default component.exports